export default __webpack_public_path__ + "static/media/ic_stmatic_24.d59821ef.svg";